import { Container } from 'pixi.js';
import type { Scene } from './Scene';
import type { SceneType } from './SceneType';

export class SceneManager {
  private scenes = new Map<SceneType, Scene>();
  private currentScene: Scene | null = null;
  private currentType: SceneType | null = null;
  private stage: Container;

  constructor(stage: Container) {
    this.stage = stage;
  }

  register(type: SceneType, scene: Scene): void {
    this.scenes.set(type, scene);
  }

  go(type: SceneType, context?: unknown): void {
    const scene = this.scenes.get(type);
    if (!scene) {
      throw new Error(`Scene not registered: ${type}`);
    }

    if (this.currentScene) {
      this.currentScene.exit();
      this.stage.removeChild(this.currentScene.container);
    }

    this.currentScene = scene;
    this.currentType = type;
    this.stage.addChild(scene.container);
    scene.enter(context);
  }

  update(deltaTime: number): void {
    this.currentScene?.update(deltaTime);
  }

  get current(): SceneType | null {
    return this.currentType;
  }
}
